<template>
    <v-row class="ma-0 pb-offset">
        <v-col class="pa-0" cols="12">
            <crud
                title="Tipo Eventi"
                action-icon='settings'
                model-def='generaltypes-event_type'
                action-position='absolute'
                crudDialog
            ></crud>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'calendar-options',
        components: {},
        props: {},
        data() {
            return {

            }
        },
        mounted() {
            this.$store.commit('endProgress')
        }
    }
</script>